import { ReactNode } from 'react'
import { IGridItem, TLayout } from '../../GridLayout/grid.types'
import mainGridLayoutConstants from './mainGridLayout.constants'

const generateLayout = (children: Record<IGridItem['key'], ReactNode>, layout: TLayout) => {
  if (!layout) return []

  const layoutCopy = []
  const boundsDict = Object.fromEntries(
    mainGridLayoutConstants.initLayout.map((item) => [
      item.key,
      { ...mainGridLayoutConstants.defaultBounds, ...item.bounds },
    ])
  )

  for (let item of layout) {
    layoutCopy.push({ ...item, children: children[item.key] ?? null, bounds: boundsDict[item.key] })
  }
  return layoutCopy
}

const mainGridLayoutUtils = { generateLayout }

export default mainGridLayoutUtils
